const comImgParallax = (() => {

  const parallaxElem = document.querySelectorAll('.js-parallax');
  if (parallaxElem.length > 0) {

    const targets = document.querySelectorAll('.js-parallax-box');

    targets.forEach((target) => {
      gsap.fromTo(target.querySelector('.js-parallax'), {
        y: 0,
      }, {
        y: -100, // y方向-に60px移動させる
        ease: "none", // イージングなし
        scrollTrigger: {
          trigger: target, // ScrollTriggerの開始位置を計算するために使用される要素
          start: "top bottom", // 1つ目の値がtriggerで指定した要素の開始位置　2つ目の値が画面の開始位置
          end: "bottom top", // 1つ目の値がtriggerで指定した要素の終了位置　2つ目の値が画面の終了位置
          scrub: 0, // 要素を1秒遅れで追従させる
          // markers: true, // 開始位置、終了位置を調整確認する際に使用します
        }
      });
    });

  }


  const parallaxReElem = document.querySelectorAll('.js-parallax-re');
  if (parallaxReElem.length > 0) {

    const targets = document.querySelectorAll('.js-parallax-box-re');

    targets.forEach((target) => {
      gsap.fromTo(target.querySelector('.js-parallax-re'), {
        y: 0,
      }, {
        y: 100, // y方向-に60px移動させる
        ease: "none", // イージングなし
        scrollTrigger: {
          trigger: target, // ScrollTriggerの開始位置を計算するために使用される要素
          start: "top bottom", // 1つ目の値がtriggerで指定した要素の開始位置　2つ目の値が画面の開始位置
          end: "bottom top", // 1つ目の値がtriggerで指定した要素の終了位置　2つ目の値が画面の終了位置
          scrub: 0, // 要素を1秒遅れで追従させる
          // markers: true, // 開始位置、終了位置を調整確認する際に使用します
        }
      });
    });

  }

})();
export default comImgParallax;